import { useRef } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Step1MobileLocalityForm = ({
  isActive = true,
  onNext,
  formData,
  setFormData,
  requestOtp,
  loading,
}) => {
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  const cityInputRef = useRef(null);

  const handleSubmit = async () => {
    if (!isActive) return;
    if (loading) return;
    
    if (!formData.phoneNumber) {
      alert("Please enter your phone number");
      return;
    }
    try {
      await requestOtp({ phone: formData.phoneNumber });
      // console.log("OTP requested:", response);
      onNext();
    } catch (error) {
      console.error("OTP request failed:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  return (
    <div className="w-full  bg-white rounded-2xl shadow-xl overflow-hidden  flex flex-col justify-center p-6 sm:p-8">
      <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-6">
        Let's get started
      </h1>

      <div className="space-y-5">
        <div>
          <label className="block ml-1 text-sm font-medium text-gray-800 mb-2">
            Enter contact number <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            required
            value={formData.phoneNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                handleChange("phoneNumber", value);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                cityInputRef.current?.focus();
              }
            }}
            placeholder="Phone Number"
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-btn-brandRed focus:border-transparent outline-none transition-all"
            pattern="\d{10}"
            maxLength={10}
            inputMode="numeric"
          />
        </div>

        <div>
          <label className="block ml-1 text-sm font-medium text-gray-800 mb-2">
            Property City{" "}
            <span className="text-gray-500 text-xs font-normal">
              (Optional)
            </span>
          </label>
          <input
            ref={cityInputRef}
            type="text"
            value={formData.city}
            onChange={(e) => handleChange("city", e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit();
              }
            }}
            placeholder="Locality"
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-btn-brandRed focus:border-transparent outline-none transition-all"
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`w-full flex items-center justify-center gap-2 bg-btn-brandRed  hover:bg-btn-brandRedHover text-white font-semibold text-base py-3.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] mt-2 ${
            loading ? "opacity-80 cursor-not-allowed" : ""
          }`}
        >
          {loading && (
            <AiOutlineLoading3Quarters className="animate-spin text-lg" />
          )}
          Continue
        </button>
      </div>
    </div>
  );
};

export default Step1MobileLocalityForm;
